import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Panel, Button } from 'govuk-react-jsx';

import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';

import { useSetReduxState } from '../../hooks/useResetReduxState';

const AccountCreated = () => {
  const [setResetReduxState] = useSetReduxState();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  const handleBtnClick = () => {
    setResetReduxState('pmcJourney', 'registrationJourney');
    window.location.assign('/signin');
  };

  return (
    <>
      <Panel
        titleChildren={copyProvider.getCopy(
          'pmcClientReg.AccountCreated.s1',
          'Account created'
        )}
      />
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy(
          'pmcClientReg.AccountCreated.s2',
          'What happens next'
        )}
      </h2>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcClientReg.AccountCreated.s3',
          'You can now use your email and password to sign in to your account. You will be able to:'
        )}
      </p>
      <ul className="govuk-list govuk-list--bullet">
        <li>
          {copyProvider.getCopy(
            'pmcClientReg.AccountCreated.s4',
            'register your clients'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'pmcClientReg.AccountCreated.s5',
            'apply for grants on behalf of your clients'
          )}
        </li>
      </ul>
      <p className="govuk-body govuk-!-margin-top-7">
        {copyProvider.getCopy(
          'pmcClientReg.AccountCreated.s6',
          'Read more about the '
        )}
        <Link
          to={{}}
          onClick={() =>
            window.open(
              'https://www.gov.uk/government/collections/government-grants-for-low-emission-vehicles?_ga=2.184459878.1544765600.1633270753-1019348812.1619020702',
              '_blank'
            )
          }
          className="govuk-link"
        >
          {copyProvider.getCopy(
            'pmcClientReg.AccountCreated.s7',
            'Grant schemes for electric vehicle charging infrastructure (opens in new tab)'
          )}
        </Link>
      </p>
      <Button
        className="govuk-button govuk-!-margin-top-3"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'pmcClientReg.AccountCreated.s8',
          'Sign in to your account'
        )}
      </Button>
      <h3 className="govuk-heading-s govuk-!-margin-top-4">
        {copyProvider.getCopy(
          'pmcClientReg.AccountCreated.s9',
          'Help to make this service better'
        )}
      </h3>
      <p className="govuk-body">
        <Link
          to={{}}
          onClick={() =>
            window.open('https://www.smartsurvey.co.uk/s/EV-grants/', '_blank')
          }
          className="govuk-link"
        >
          {copyProvider.getCopy(
            'pmcClientReg.AccountCreated.s10',
            'What did you think of this service? '
          )}
        </Link>
        {copyProvider.getCopy(
          'pmcClientReg.AccountCreated.s11',
          '(takes 30 seconds)'
        )}
      </p>
    </>
  );
};

export default AccountCreated;
